import EnvService from '@/services/EnvService';

class LogService {
  static log(...text) {
    if (EnvService.localOrDev()) console.log(...text);
  }
}

export default LogService;
